import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { useLang } from "@/lib/i18n";
import { inputCls } from "@/lib/forms";

const MONTHS = {
  en: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  es: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
};

const Field = ({ id, label, hint, children }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-hacienda-cream">{label}{hint && <span className="text-hacienda-cream/60"> ({hint})</span>}</Label>
    {children}
  </div>
);

export const VipFields = ({ form, update }) => {
  const { t, lang } = useLang();
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      <Field id="vip-first" label={`${t("vip.firstName")} *`}>
        <Input id="vip-first" required autoComplete="given-name" value={form.firstName} onChange={(e) => update("firstName", e.target.value)} className={inputCls} data-testid="vip-firstname-input" />
      </Field>
      <Field id="vip-mobile" label={`${t("vip.mobile")} *`}>
        <Input id="vip-mobile" type="tel" required autoComplete="tel" inputMode="tel" value={form.mobile} onChange={(e) => update("mobile", e.target.value)} className={inputCls} data-testid="vip-mobile-input" />
      </Field>
      <Field id="vip-email" label={`${t("vip.email")} *`}>
        <Input id="vip-email" type="email" required autoComplete="email" value={form.email} onChange={(e) => update("email", e.target.value)} className={inputCls} data-testid="vip-email-input" />
      </Field>
      <Field id="vip-month" label={t("vip.birthday")} hint={t("vip.optional")}>
        <select id="vip-month" value={form.birthdayMonth} onChange={(e) => update("birthdayMonth", e.target.value)} className={`w-full rounded-md border px-3 text-sm text-hacienda-charcoal ${inputCls}`} data-testid="vip-month-select">
          <option value="">—</option>
          {MONTHS[lang].map((m) => <option key={m} value={m}>{m}</option>)}
        </select>
      </Field>
    </div>
  );
};

export const VipConsent = ({ checked, onChange }) => {
  const { t } = useLang();
  return (
    <div className="flex items-start gap-3">
      <Checkbox id="vip-consent" checked={checked} onCheckedChange={(v) => onChange(v === true)} className="mt-1 border-hacienda-cream data-[state=checked]:bg-hacienda-terracotta data-[state=checked]:border-hacienda-terracotta" data-testid="vip-consent-checkbox" />
      <Label htmlFor="vip-consent" className="text-hacienda-cream/80 text-xs leading-relaxed font-normal cursor-pointer">
        {t("vip.consent")} <Link to="/privacy-policy" className="underline text-hacienda-amber">{t("nav.privacy")}</Link>
      </Label>
    </div>
  );
};
